const style = {
    main: "flex flex-col gruppo pb-14 border-b-2 border-black border-dotted md:border-b-0 mb-10 md:mb-0",
    header: "w-full text-center text-2xl font-semibold",
    body: "flex flex-col md:flex-row items-center",
}

export default style